<footer class="footer">
  <div class="footer__top">
    <div class="container footer__container">
      <div class="footer__row">
        <div class="footer__col">
          <div class="footer__title-sm">Звонки по всей России</div>
          <a class="footer__number" href="tel:88002004402">8 800 200-44-02</a>
        </div>
        <div class="footer__col">
          <div class="footer__title-sm">Звонки по Москве</div>
          <a class="footer__number" href="tel:+74959884422">+7 (495) 988-44-22</a>
        </div>
        <div class="footer__col">
          <div class="footer__title-sm">Мы в социальных сетях</div>
          <div class="footer__social">
            <a class="footer__social-link" href="//vk.com/club_ndv_realty" target="_blank">
              <app-ui-icon [name]="'icon-vk'" [width]="15" [height]="9"></app-ui-icon>
            </a>
            <a class="footer__social-link" href="https://t.me/ndv_supermarket" target="_blank">
              <app-ui-icon [name]="'icon-twitter'" [width]="14" [height]="12"></app-ui-icon>
            </a>
            <a class="footer__social-link" href="https://zen.yandex.ru/id/5d403f74d5135c110a99f5f3" target="_blank">
              <app-ui-icon [name]="'icon-zen'" [width]="16" [height]="16"></app-ui-icon>
            </a>
            <a class="footer__social-link" href="//instagram.com/ndv__realty/" target="_blank">
              <app-ui-icon [name]="'icon-instagram'" [width]="12" [height]="12"></app-ui-icon>
            </a>
            <a class="footer__social-link" href="https://www.youtube.com/@ndv-supermarket" target="_blank">
              <app-ui-icon [name]="'icon-youtube'" [width]="14" [height]="10"></app-ui-icon>
            </a>
          </div>
        </div>
        <div class="footer__col">
          <div class="footer__title-sm">Есть вопросы или предложения?</div>
          <app-button [square]="true" [size]="'sm'" class="footer__btn" (click)="qualityQuestionFormToggle()">Напишите нам</app-button>
        </div>
      </div>
      <!--Форма обратной связи-->
      <app-callback-form
        [showCallbackForm]="qualityQuestionFormVisibility"
        (showCallbackFormChange)="onShowCallbackFormChange($event)"
      >
      </app-callback-form>
    </div>
  </div>
  <div class="footer__mid">
    <div class="container footer__container">
      <div class="footer__row">
        <div class="footer__col">
          <div class="footer__title-list">О компании</div>
          <ul class="footer__list footer__list--menu">
            <li class="footer__list-item"><a class="footer__list-link" href="/o-kompanii">О компании</a></li>
            <li class="footer__list-item"><a class="footer__list-link" href="/press-centr">Пресс-центр</a></li>
            <li class="footer__list-item"><a class="footer__list-link" href="/kontakty">Офисы продаж</a></li>
            <li class="footer__list-item"><a class="footer__list-link" href="/kontakty/centralnyj-ofis">Центральный офис</a></li>
            <li class="footer__list-item"><a class="footer__list-link" href="/vacancies">Вакансии</a></li>
          </ul>
        </div>
        <div class="footer__col">
          <div class="footer__title-list">Выбор квартиры</div>
          <ul class="footer__list">
            <li class="footer__list-item">
              <a href="/kupit-kvartiru-all/all" class="footer__list-link">Все квартиры <sup class="badge">NEW</sup></a>
            </li>
            <li class="footer__list-item">
              <a href="/kupit-kvartiru-all/new" class="footer__list-link">Квартиры в новостройках <sup class="badge">NEW</sup></a>
            </li>
            <li class="footer__list-item">
              <a href="/kupit-kvartiru-all/resale" class="footer__list-link">Квартиры на вторичке</a>
            </li>
            <li class="footer__list-item">
              <a href="/kupit-kvartiru-all/all/room-studio" class="footer__list-link">Квартиры студии</a>
            </li>
            <li class="footer__list-item">
              <a href="/kupit-kvartiru-all/all/room-1" class="footer__list-link">Однокомнатные квартиры</a>
            </li>
            <li class="footer__list-item">
              <a href="/kupit-kvartiru-all/all/room-2" class="footer__list-link">Двухкомнатные квартиры</a>
            </li>
            <li class="footer__list-item">
              <a href="/kupit-kvartiru-all/all/room-3" class="footer__list-link">Трехкомнатные квартиры</a>
            </li>
          </ul>
        </div>
        <div class="footer__col">
          <div class="footer__title-list">Квартиры по расположению</div>
          <ul class="footer__list">
            <li class="footer__list-item">
              <a href="/kupit-kvartiru-all/all/r-moskva" class="footer__list-link">Квартиры в Москве</a>
            </li>
            <li class="footer__list-item">
              <a href="/kupit-kvartiru-all/all/o-novomoskovskij" class="footer__list-link">Квартиры в Новой Москве</a>
            </li>
            <li class="footer__list-item">
              <a href="/kupit-kvartiru-all/all/r-moskovskaya-oblast" class="footer__list-link">Квартиры в Подмосковье</a>
            </li>
            <li class="footer__list-item">
              <a href="/kupit-kvartiru-all/all/near-subway" class="footer__list-link">Квартиры у метро</a>
            </li>
            <li class="footer__list-item">
              <a href="/kupit-kvartiru-all/all/o-centralnyj" class="footer__list-link">Квартиры в центре Москвы</a>
            </li>
            <li class="footer__list-item">
              <a href="/kupit-kvartiru-all/all/o-severnyj" class="footer__list-link">Квартиры на севере Москвы</a>
            </li>
            <li class="footer__list-item">
              <a href="/kupit-kvartiru-all/all/o-yuzhnyj" class="footer__list-link">Квартиры на юге Москвы</a>
            </li>
            <li class="footer__list-item">
              <a href="/kupit-kvartiru-all/all/o-zapadnyj" class="footer__list-link">Квартиры на западе Москвы</a>
            </li>
            <li class="footer__list-item">
              <a href="/kupit-kvartiru-all/all/o-vostochnyj" class="footer__list-link">Квартиры на востоке Москвы</a>
            </li>
          </ul>
        </div>
        <div class="footer__col">
          <div class="footer__title-list">Ипотека</div>
          <ul class="footer__list">
            <li class="footer__list-item">
              <a href="/ipoteka" class="footer__list-link">Ипотечный калькулятор</a>
            </li>
            <li class="footer__list-item">
              <a href="/ipoteka#newbuilding" class="footer__list-link">Ипотека на новостройку</a>
            </li>
            <li class="footer__list-item">
              <a href="/ipoteka#resale" class="footer__list-link">Ипотека на вторичку</a>
            </li>
            <li class="footer__list-item">
              <a href="/ipoteka#refinancing" class="footer__list-link">Рефинансирование ипотеки</a>
            </li>
            <li class="footer__list-item">
              <a href="/ipoteka/materinskij-kapital" class="footer__list-link">Семейная ипотека</a>
            </li>
            <li class="footer__list-item">
              <a href="/ipoteka/voennaya" class="footer__list-link">Военная ипотека</a>
            </li>
            <li class="footer__list-item">
              <a href="/ipoteka/s-gospodderzhkoj" class="footer__list-link">Господдержка</a>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
  <div class="footer__bottom">
    <div class="container footer__container">
      <div class="footer__bottom-inner">
        <div class="footer__copyright">
          © НДВ Супермаркет Недвижимости, 1997-{{ getCurrentYear() }} г. Все права защищены. <br />
          Ведущее агентство недвижимости в Москве и Московской области. <br />
          Представленная информация не является публичной офертой. <br />
          <a href="#" class="footer__copyright-link">Политика конфиденциальности компании</a>
        </div>
        <div class="footer__store">
          <a href="https://play.google.com/store/apps/details?id=com.ndv" class="footer__store-link">
            <img [src]="'/assets/images/google-play.svg'" alt="Google Play">
          </a>
          <a href="https://apps.apple.com/ru/app/%D0%BD%D0%B4%D0%B2/id1539878294" class="footer__store-link">
            <img [src]="'/assets/images/app-store.svg'" alt="App Store">
          </a>
        </div>
      </div>
    </div>
  </div>
</footer>
